import { TFieldConfig } from "../types/common";

export const changePasswordFields: TFieldConfig[] = [
  {
    field_name: "old_password",
    type: "password",
    label: "Old password",
    props: { required: true },
  },
  {
    field_name: "password",
    type: "password",
    label: "New password",
    props: { required: true },
  },
  {
    field_name: "conf_password",
    type: "password",
    label: "New password confirm",
    props: { required: true },
  },
];
